import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../shared/media-query';
import { toggleSection, onClickAccHandler, sectionIsOpen, accScroll } from '../../shared/page-accordion';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        let openedSections = [];

        if (props.hash) {
            openedSections.push(props.hash);
        }

        this.state = {
            openedSections: openedSections,
            category: props.category,
            code: props.upc,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.hash != this.props.hash) {
            if (nextProps.hash != '') {
                if (nextProps.hash == 'all-cards') {
                    this.setState({ openedSections: []});
                    accScroll('all-cards', 400);
                } else {
                    let opened = toggleSection(this.state.openedSections, nextProps.hash);
                    const state = this.state;
                    state.openedSections = opened;
                    this.setState(state);
                }
            }
            return true;
        }

        if (nextState != this.state) {
            return true;
        }

        if (nextProps.report != this.props.report) {
            return true;
        }

        return false;
    }

    render({ report }) {
        if (report) {
            return (
                <tarot-interps>
                    {this.renderInterps()}
                </tarot-interps>
            );
        }

        return (<tarot-interps />);
    }

    onClickHandler = (id, e) => {
        e.preventDefault();
        let clickResult = onClickAccHandler(this.state.openedSections, id, this.props.hash);
        const state = this.state;

        this.props.trackEvent([
            'Click',
            `Readings_${this.props.report.product_code}:Interp_${id.split('_').map((word) => {
                return word[0].toUpperCase() + word.slice(1);
            }).join('_')
            }`,
        ]);

        if (id === 'all-cards') {
            state.open_chapters = [];
            clickResult[2] = false;
        } else {
            state.openedSections = clickResult[0];
            this.setState(state);
        }

        if (clickResult[1] == true) {
            this.props.routeTo(id);
        }

        if (clickResult[2] == true) {
            accScroll(id, 400);
        }
    }

    renderInterps = () => {
        const spread = this.props.report.product_code;
        const report = this.props.report;
        if (spread.match(/-1-card/)) {
            return (
                <div>
                    <section id='generic-interps' className='generic-interp-text'>
                        {
                            report.product.display.sections.map((section, loop) => (
                                this.renderNonAccordionItem(section, loop)
                            ))
                        }
                    </section>
                    {this.renderReportFooter()}
                </div>
            );
        } else if (spread == 'yes-or-no-tarot-redux') {
            return (
                <div>
                    <section id='generic-interps' className='generic-interp-text'>
                        {
                            report.product.display.sections[1].block.map(block => (
                                block.content[0].body.map(body => (
                                    <p dangerouslySetInnerHTML={{ __html: body }} />
                                ))
                            ))
                        }
                    </section>
                    {this.renderSpecificCards()}
                </div>
            );
        } else if (!report.product.display.show_card_descriptions) {
            return (
                <section className='no-border'>
                    {
                        report.product.display.sections[1].block[0].content.map((content, loop) => (
                            this.renderCardInterpretation(content, loop)
                        ))
                    }
                </section>
            );
        }
        return (
            <section className='interp-accordion'>
                {
                    report.product.display.sections.map((section, loop) => (
                        this.renderAccItem(section, loop)
                    ))
                }
            </section>
        );
    }

    renderSpecificCards = () => {
        if (this.props.report.product.display.sections[2].block[0]) {
            return (
                <section className='interp-accordion'>
                    {this.props.report.product.display.sections[2].block[0].content.map(content => (
                        !!content.card_info && this.renderAccItemYesNo(content)
                    ))}
                </section>
            );
        }

        return null;
    }

    /* eslint-disable max-len */
    renderAccItem = (section, loop) => {
        const id = section.section_code;
        const isOpen = sectionIsOpen(this.state.openedSections, id);
        let imageClass = '';

        if (
            !!this.props.report.product.inputs.cards[loop - 1]
            &&
            !!this.props.report.product.inputs.cards[loop - 1].orientation
        ) {
            imageClass = ' orientation-' + this.props.report.product.inputs.cards[loop - 1].orientation;
        }

        return (
            (section.super_title != 0) && (
                <div
                    className={`interp-accordion-item ${isOpen ? ' accordion-open' : ' accordion-closed'}`}
                >
                    <a
                        href={`#${ id }`}
                        onClick={(e) => this.onClickHandler(id, e)}
                        id={id}
                        className='interp-accordion-item-tab'
                    >
                        <row className='is-aligned-center has-padding-10-top has-padding-10-bottom'>
                            <column className='is-hidden-print is-1 is-2-mobile has-text-center'>
                                <img
                                    className={`interp-thumb${imageClass}`}
                                    loading='lazy'
                                    src={section.block.card_info.images.table}
                                    alt={section.block.card_info.name}
                                />
                            </column>
                            <column className='is-11 is-10-mobile'>
                                <div className='has-weight-500 has-text-size-18 has-text-color-black no-hover'>
                                    {section.title}
                                </div>
                                <div className='has-margin-3-top has-margin-7-bottom has-text-size-14 has-text-boulder no-hover'>
                                    {section.block.card_info.name}
                                </div>
                            </column>
                        </row>
                    </a>
                    <row className='interp-accordion-item-content'>
                        <column>
                            <img
                                className={`interp-card${imageClass}`}
                                loading='lazy'
                                src={section.block.card_info.images.full}
                                alt={section.block.card_info.name}
                                align='left'
                            />
                            {this.renderItemText(section)}
                            <p className='is-hidden-print has-text-right has-margin-0-bottom'>
                                <a
                                    href='#'
                                    onClick={(e) => this.onClickHandler('all-cards', e)}
                                >
                                    View All Cards
                                </a>
                            </p>
                        </column>
                    </row>
                </div>
            )
        );
    }

    renderNonAccordionItem = (section) => {
        if (section.super_title != 0) {
            const cardInfo = section.block.card_info;
            const cardSlug = this.props.deck ? this.props.deck.cards[cardInfo.index].canonical_rank : '';

            return (
                <div className='has-text-left has-margin-30-top'>
                    <row className='has-margin-10-left has-margin-10-right has-margin-30-top'>
                        <column>
                            <h2 className='has-margin-20-bottom'>
                                {section.block.card_info.name}
                            </h2>
                        </column>
                    </row>
                    <row className='has-margin-10-left has-margin-10-right'>
                        <column>
                            {this.renderItemText(section)}
                        </column>
                    </row>
                    <row className='has-margin-10-left'>
                        <a
                            href={`/tarot/cards/${cardSlug}`}
                            onClick={() => this.props.trackEvent([
                                'Click',
                                `Readings_${this.props.report.product_code}:LearnMore_${cardSlug}`,
                            ])}
                        >
                            {`Learn More About the ${cardInfo.name} Tarot Card`}
                        </a>
                    </row>
                </div>
            );
        }

        return null;
    }

    renderItemText = (section) => {
        return (
            !!section.block.card_in_position.content[0] && (
                <div>
                    {!!section.block.card_in_position.content[0].title
                    && !this.props.report.product_code.match(/-1-card/)
                    && (
                        MQ.isMobile()
                            ?
                            <h4 className='has-margin-20-bottom'>
                                {section.block.card_in_position.content[0].title}
                            </h4>
                            :
                            <h3 className='has-margin-20-bottom'>
                                {section.block.card_in_position.content[0].title}
                            </h3>
                    )}
                    <div className='interp-accordion-item-text'>
                        {section.block.card_in_position.content[0].body.map(paragraph =>
                            <p>{paragraph}</p>
                        )}
                        {!!section.block.card_description_oriented && (
                            section.block.card_description_oriented.content[0].body.map(paragraph =>
                                <p>{paragraph}</p>
                            )
                        )}
                    </div>
                </div>
            )
        );
    }

    renderAccItemYesNo = (content) => {
        const id = content.card_info.canonical_rank;
        const isOpen = sectionIsOpen(this.state.openedSections, id);
        return (
            <div
                className={`interp-accordion-item ${isOpen ? ' accordion-open' : ' accordion-closed'}`}
                id={id}
            >
                <a
                    href={`#${id}`}
                    className='interp-accordion-item-tab no-hover'
                    onClick={(e) => this.onClickHandler(id, e)}
                >
                    <row className='is-aligned-center has-padding-10-top has-padding-10-bottom'>
                        <column className='is-1 is-2-mobile has-text-center'>
                            <img
                                className='interp-thumb'
                                src={content.card_info.images.table}
                                alt={content.card_info.name}
                            />
                        </column>
                        <column className='is-11 is-10-mobile'>
                            <div className='has-weight-500 has-text-size-18 has-text-color-black no-hover'>
                                {content.card_info.name}
                            </div>
                        </column>
                    </row>
                </a>
                <row className='interp-accordion-item-content'>
                    <column>
                        <img
                            className='interp-card'
                            src={content.card_info.images.full}
                            alt={content.card_info.name} align='left'
                        />
                    </column>
                    <column>
                        {!!content.card_info.one_liner && (
                            MQ.isMobile()
                                ?
                                <h4 className='has-margin-20-bottom'>
                                    {content.card_info.one_liner}
                                </h4>
                                :
                                <h3 className='has-margin-20-bottom'>
                                    {content.card_info.one_liner}
                                </h3>
                        )}
                        {!!content.body && !!content.body[0] && (
                            <p>{content.body[0]}</p>
                        )}
                        <p className='is-hidden-print has-text-right has-margin-0-bottom'>
                            <a
                                className='is-hidden-print'
                                href='#all-cards'
                                onClick={(e) => this.onClickHandler('all-cards', e)}
                            >
                                View All Cards
                            </a>
                        </p>
                    </column>
                </row>
            </div>
        );
    }

    renderCardInterpretation = (content, loop) => {
        return (
            <div>
                <h1 className='has-text-center'>
                    {content.title}
                </h1>
                <h4 className='has-text-center has-margin-20-bottom-desktop has-margin-10-left-mobile has-margin-10-right-mobile'>
                    {content.sub_title}
                </h4>
                {(loop < 2)
                    ?
                    <row className='is-wrap is-justified-center'>
                        <column className='is-1 is-4-mobile has-padding-10-top'>
                            <img src={content.card_info[0].images.full} alt={content.card_info[0].rank_name} />
                        </column>
                        <column className='is-11 is-12-mobile'>
                            <p className='has-margin-10-left has-margin-10-right-mobile has-padding-15-left-tablet has-padding-15-left-desktop'>
                                {content.body[0]}
                            </p>
                        </column>
                    </row>
                    :
                    <div>
                        {(loop == 2) ? this.renderImages(content.card_info) : null}
                        <p className='has-margin-10-left-mobile has-margin-10-right-mobile'>
                            {content.body[0]}
                        </p>
                    </div>
                }
            </div>
        );
    }

    renderReportFooter = () => {
        return (
            <section>
                <p className='is-h2 has-margin-5-bottom is-hidden-print fancy-title has-margin-40-top has-text-center'>
                    Need More Clarity?
                </p>
                <row className='is-hidden-print has-margin-10-top'>
                    <column className='is-12 has-text-center'>
                        <a
                            className='button-pink-alternate'
                            href='/readings-reports/tarot'
                            onClick={() => this.props.trackEvent([
                                'Click',
                                `Readings_${this.props.report.product_code}:GetATarotReading`,
                            ])}
                        >
                            GET A TAROT READING
                        </a>
                    </column>
                </row>
            </section>
        );
    }

    renderImages = (card_info) => {
        return (
            <div className='has-background'>
                {
                    card_info.map(card => (
                        <img src={card.images.full} alt={card.rank_name} />
                    ))
                }
            </div>
        );
    }
    /* eslint-enable max-len */
}

const mapStateToProps = (state) => ({
    deck: state.deck,
    report: state.report,
    hash: state.route,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (hash) => dispatch({ type: 'route:to', payload: hash }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
